import { atom, useAtom } from 'jotai';

import type { AiSummary } from './use-load-debtor-ai-summary';

export const isOutdatedStateAtom = atom<NonNullable<AiSummary>['isOutdated']>(false);

export const useIsSummaryOutdated = () => {
  const [isOutdated, setIsOutdated] = useAtom(isOutdatedStateAtom);

  return { isOutdated, setIsOutdated };
};
